/// <amd-module name="Analytics/Boards/BoardsQueries/TeamsQuery" />
import { AnalyticsCacheableQueryBase, CommonFeatureCommandName } from "Analytics/Common/AnalyticsCacheableQueryBase";
import { ODataQueryOptions } from "Analytics/Common/ODataQueryOptions";
import { latestODataVersion } from "Analytics/Common/Utilities/QueryUtilities";
import { IVssPageContext } from "VSS/Platform/Context";

/** Basic Team info */
export interface TeamInfo {
    TeamId: string;
    TeamName: string;
    ProjectSK: string;
}

export class TeamsQuery extends AnalyticsCacheableQueryBase<TeamInfo[]> {
    private static generateQueryOptions(project: string): ODataQueryOptions {
        return {
            entityType: "Teams",
            oDataVersion: latestODataVersion,
            project: project,
            $orderby: "TeamName",
            $select: "TeamId,TeamName,ProjectSK"
        };
    }
    /**
     * Retrieves teams associated with the specified project
     */
    public static onProject(pageContext: IVssPageContext, projectId: string): TeamsQuery {
        return new TeamsQuery(TeamsQuery.generateQueryOptions(projectId));
    }

    constructor(queryOptions: ODataQueryOptions) {
        super(CommonFeatureCommandName, queryOptions);
    }

    public getQueryName(): string {
        return "TeamsQuery";
    }
}
